// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as PricingDashboardDataMachine from "../../../../../app/PricingDashboardDataMachine.bs.js";

function getInitialState(param) {
  return {
          modifications: {
            TAG: /* Loading */0,
            _0: undefined
          },
          zones: {
            TAG: /* Loading */0,
            _0: undefined
          },
          clusters: {
            TAG: /* Loading */0,
            _0: undefined
          },
          initial_priorities: /* [] */0,
          modified_priorities: /* [] */0,
          edited_modifications: {}
        };
}

function reducer(action, state) {
  if (typeof action === "number") {
    return {
            modifications: state.modifications,
            zones: state.zones,
            clusters: state.clusters,
            initial_priorities: state.initial_priorities,
            modified_priorities: /* [] */0,
            edited_modifications: {}
          };
  }
  switch (action.TAG | 0) {
    case /* SetModifications */0 :
        var modifications = action._0;
        var tmp;
        switch (modifications.TAG | 0) {
          case /* Live */1 :
              tmp = List.map((function (a) {
                      return a.key_details.external_id;
                    }), modifications._0);
              break;
          case /* Loading */0 :
          case /* Error */2 :
              tmp = /* [] */0;
              break;
          
        }
        return {
                modifications: modifications,
                zones: state.zones,
                clusters: state.clusters,
                initial_priorities: tmp,
                modified_priorities: state.modified_priorities,
                edited_modifications: state.edited_modifications
              };
    case /* SetZones */1 :
        return {
                modifications: state.modifications,
                zones: action._0,
                clusters: state.clusters,
                initial_priorities: state.initial_priorities,
                modified_priorities: state.modified_priorities,
                edited_modifications: state.edited_modifications
              };
    case /* SetClusters */2 :
        return {
                modifications: state.modifications,
                zones: state.zones,
                clusters: action._0,
                initial_priorities: state.initial_priorities,
                modified_priorities: state.modified_priorities,
                edited_modifications: state.edited_modifications
              };
    case /* SetPriority */3 :
        return {
                modifications: state.modifications,
                zones: state.zones,
                clusters: state.clusters,
                initial_priorities: state.initial_priorities,
                modified_priorities: action._0,
                edited_modifications: state.edited_modifications
              };
    case /* SetEditModification */4 :
        var edited_modifications = state.edited_modifications;
        edited_modifications[action._0] = action._1;
        return {
                modifications: state.modifications,
                zones: state.zones,
                clusters: state.clusters,
                initial_priorities: state.initial_priorities,
                modified_priorities: state.modified_priorities,
                edited_modifications: edited_modifications
              };
    
  }
}

function fetchModifications(campaign_id, dispatch) {
  return function (param) {
    return PricingDashboardDataMachine.fetchModifications(campaign_id, (function (data) {
                  return Curry._1(dispatch, {
                              TAG: /* SetModifications */0,
                              _0: {
                                TAG: /* Live */1,
                                _0: data
                              }
                            });
                }), (function (error) {
                  return Curry._1(dispatch, {
                              TAG: /* SetModifications */0,
                              _0: {
                                TAG: /* Error */2,
                                _0: error
                              }
                            });
                }), param);
  };
}

function fetchZones(geo_region_id, dispatch) {
  var partial_arg = String(geo_region_id);
  return function (param) {
    return PricingDashboardDataMachine.fetchZones(partial_arg, (function (data) {
                  return Curry._1(dispatch, {
                              TAG: /* SetZones */1,
                              _0: {
                                TAG: /* Live */1,
                                _0: data
                              }
                            });
                }), (function (error) {
                  return Curry._1(dispatch, {
                              TAG: /* SetZones */1,
                              _0: {
                                TAG: /* Error */2,
                                _0: error
                              }
                            });
                }), param);
  };
}

function fetchClusters(geo_region_id, dispatch) {
  var partial_arg = String(geo_region_id);
  return function (param) {
    return PricingDashboardDataMachine.fetchClusters(partial_arg, (function (data) {
                  return Curry._1(dispatch, {
                              TAG: /* SetClusters */2,
                              _0: {
                                TAG: /* Live */1,
                                _0: data
                              }
                            });
                }), (function (error) {
                  return Curry._1(dispatch, {
                              TAG: /* SetClusters */2,
                              _0: {
                                TAG: /* Error */2,
                                _0: error
                              }
                            });
                }), param);
  };
}

export {
  getInitialState ,
  reducer ,
  fetchModifications ,
  fetchZones ,
  fetchClusters ,
  
}
/* PricingDashboardDataMachine Not a pure module */
